<template>
  <GdashTile
    icon="<path d='M12,3L22,12H19V20H5V12H2L12,3M9.22,8.93C8.75,9.4 8.5,10.03 8.5,10.75C8.5,12.43 10.54,13.07 11.76,13.46C13.26,13.93 13.47,14.21 13.5,14.25C13.5,15 12.15,15 12,15V15C11.37,15 11.03,14.88 10.86,14.78C10.67,14.67 10.5,14.5 10.5,14H8.5C8.5,15.43 9.24,16.16 9.85,16.5C10.18,16.7 10.57,16.84 11,16.92V18H13V16.91C14.53,16.61 15.5,15.62 15.5,14.25C15.5,12.67 13.88,12.03 12.36,11.55C10.8,11.06 10.53,10.77 10.5,10.75C10.5,10.5 10.57,10.41 10.64,10.34C10.85,10.13 11.36,10 12,10V10C12.68,10 13.5,10.13 13.5,10.75H15.5C15.5,9.34 14.56,8.37 13,8.09V7H11V8.08C10.26,8.21 9.65,8.5 9.22,8.93Z' />"
    header="世帯収入"
  >
    <div>
      <div class="tile-description">
        <b>{{ name }}の</b> 住宅価格の中央値は
        <b>${{ data.medianHomeValueMort | format("n1") }}</b> ({{
          getIndexDescription(
            (100 * data.medianHomeValueMort) / dataUS.medianHomeValueMort
          )
        }}).
      </div>
      <table>
        <tbody>
          <tr>
            <td>住宅価格指数</td>
            <td>
              <GdashGauge
                :value="data.medianHomeValueMort / dataUS.medianHomeValueMort"
                :palette="palette"
              />
            </td>
          </tr>
          <tr>
            <td>世帯収入指数</td>
            <td>
              <GdashGauge
                :value="data.medianIncome / dataUS.medianIncome"
                :palette="palette"
              />
            </td>
          </tr>
          <tr>
            <td>純資産価値指標</td>
            <td>
              <GdashGauge
                :value="data.netWorth / dataUS.netWorth"
                :palette="palette"
              />
            </td>
          </tr>
        </tbody>
      </table>
      <div class="tile-chart">
        <div class="btn-group btn-group-toggle">
          <label v-bind:class="{ btn: true, 'btn-outline-secondary': true, active: !detailed }">
            <input type="radio" v-bind:value="false" v-model="detailed" />
            概要
          </label>
          <label v-bind:class="{ btn: true, 'btn-outline-secondary': true, active: detailed }">
            <input type="radio" v-bind:value="true" v-model="detailed" />
            詳細
          </label>
        </div>
        <div>
          <wj-flex-chart
            style="height: 350px"
            class="chart chart-bar"
            chartType="Bar"
            v-show="detailed"
            plotMargin="10 80 10 70"
            tooltipContent="{y} の世帯数は <br/> {x} です。"
            :itemsSource="getDetailedData()"
            :palette="palette"
            bindingX="name"
          >
            <wj-flex-chart-series binding="value" />
            <wj-flex-chart-axis
              wjProperty="axisX"
              :axisLine="false"
              :majorGrid="false"
              :labels="false"
            />
            <wj-flex-chart-axis
              wjProperty="axisY"
              :majorGrid="false"
              :axisLine="true"
              :labels="true"
            />
            <wj-flex-chart-data-label
              content="{y}"
              position="Right"
              :offset="6"
            />
            <wj-flex-chart-animation />
          </wj-flex-chart>

          <wj-flex-chart
            ref="homeValueChart"
            class="chart chart-bar"
            v-show="!detailed"
            chartType="Bar"
            bindingX="name"
            tooltipContent="{y} の世帯数は <br/>{x} です。"
            :itemsSource="getData()"
            :palette="palette"
          >
            <wj-flex-chart-series binding="value" />
            <wj-flex-chart-axis
              wjProperty="axisX"
              majorTickMarks="None"
              :majorGrid="true"
              :axisLine="false"
              :labels="false"
            />
            <wj-flex-chart-axis wjProperty="axisY" :majorGrid="false" />
          </wj-flex-chart>
        </div>
      </div>
    </div>
  </GdashTile>
</template>

<script>
import GdashGauge from "./GdashGauge.vue";
import GdashTile from "./GdashTile.vue";
import { Globalize } from "@mescius/wijmo";

export default {
  name: "HomeValueTile",
  components: {
    GdashGauge,
    GdashTile,
  },
  data: function () {
    return {
      detailed: false,
    };
  },
  props: {
    name: String,
    data: Object,
    dataUS: Object,
    palette: Array,
  },
  filters: {
    format(value, fmt) {
      return Globalize.format(value, fmt);
    },
  },
  methods: {
    getData() {
      const data = this.data;
      const homeValueData = [
        {
          name: "<300000",
          value:
            data.homeValue0_50K +
            data.homeValue50_100K +
            data.homeValue100_300K,
        },
        {
          name: "300000-500000",
          value: data.homeValue300_500K,
        },
        {
          name: ">500000",
          value: data.homeValue500_1000K + data.homeValue1000K,
        },
      ];
      return homeValueData;
    },
    getDetailedData() {
      const data = this.data;
      const homeValueDataDetails = [
        {
          name: "<50K",
          value: data.homeValue0_50K,
        },
        {
          name: "50K-100K",
          value: data.homeValue50_100K,
        },
        {
          name: "100K-300K",
          value: data.homeValue100_300K,
        },
        {
          name: "300K-500K",
          value: data.homeValue300_500K,
        },
        {
          name: "500K-1M",
          value: data.homeValue500_1000K,
        },
        {
          name: ">1M",
          value: data.homeValue1000K,
        },
      ];

      return homeValueDataDetails;
    },

    // get a description for an index (100 is the national average, 50 is half, 200 is double, etc)
    getIndexDescription(index) {
      if (index == 100) {
        return "全米平均";
      }
      const desc =
        index < 50
          ? '大幅に低い'
          : index < 80
          ? '低い'
          : index < 100
          ? 'やや低い'
          : index < 120
          ? 'やや高い'
          : index < 200
          ? '高い'
          : '大幅に高い';
      return '全米平均より' + desc ;
    },
  },
};
</script>
